import moment from "moment";
import * as _ from "lodash";

export function toString(ob) {
  Object.keys(ob).forEach((k) => {
    if (typeof ob[k] === "object") {
      return toString(ob[k]);
    }
    ob[k] = "" + ob[k];
  });
  return ob;
}

export function reFormatDate(date) {
  return moment(date).format("YYYY-MM-DD");
}

export function reFormatDateString(date) {
  const dateS=new Date(date);
  // if(isNaN(dateS.getTime())) return"";
  const result= `${dateS.getFullYear()}-${String(dateS.getMonth()+1).padStart(2,"0")}-${String(dateS.getDate()).padStart(2,"0")}`
  return result;
}

export const getTotalAmount = (tot) =>
  (tot?.tot_net - tot?.amountOfVat + tot?.discount)?.toFixed(2);
